import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {CreateData, getalltagsdata} from '../../Tags/TagSlice/TagsSlices'

const FieldPopupModel = ({show, handleClose}: any) => {
  const [fieldName, setFieldName] = useState('')
  const [error, setError] = useState('')

  const handleCreate = () => {
    handleClose({value: fieldName, label: fieldName})
    setFieldName('')
  }

  const handlePopupClose = () => {
    handleClose('')
    setFieldName('')
  }

  return (
    <>
      <Modal
        backdrop='static'
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-550px'
        className='vh-100'
        show={show}
        onHide={handlePopupClose}
      >
        <>
          <div className='modal-header'>
            <h1>New custom field</h1>
          </div>
          <div className='modal-body'>
            <label className='w-100'>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                Field name
              </span>
              <input
                // onBlur={() => {
                //   ;/^[a-zA-Z0-9_]{2,25}$/.test(tagName)
                //     ? setError('')
                //     : setError('please enter valid tag ')
                // }}
                value={fieldName}
                placeholder='Enter Field name'
                maxLength={25}
                className='form-control form-control-solid border-0 w-100 mt-2'
                onChange={(e: any) => {
                  // setError('')
                  setFieldName(e.target.value)
                }}
              />
              <span className='text-danger mt-1'>{error}</span>
            </label>
          </div>
          <div className='modal-footer w-100'>
            <button onClick={handlePopupClose} type='button' className='btn btn-light-primary'>
              Cancel
            </button>
            <button
              disabled={error !== '' || fieldName == ''}
              onClick={handleCreate}
              id='submit'
              type='button'
              className='btn btn-primary w-50 '
            >
              Save
            </button>
          </div>
        </>
      </Modal>
    </>
  )
}

export default FieldPopupModel
